import mobx, { extendObservable, action } from 'mobx';
import axios from 'axios';
import { includes, map } from 'lodash';
import eb from '../utils/EventBus'

class RvwdListStore {

    constructor() {
        extendObservable(this, {
            loading: true,
            reviewedDocs: [],
            searchTerm: '',
            docs: []
        });

        eb.on('search-rvwdlist', (val) => this.setSearch(val));
    }
    

   loadRvwdList = () => {

        axios.get('/api/v1/rvwdlist/docs').then(({ data }) => {
            this.loading = false;
            this.docs = data;
            this.reviewedDocs = data;
        });
       
    }

    setSearch = action((val) => {
        this.searchTerm = val;
        this.reviewedDocs = this.docs.filter(i => JSON.stringify(i).toLowerCase().indexOf(val.toLowerCase()) > -1);
    })
  
   
}

const store = new RvwdListStore();
export default store;



// WEBPACK FOOTER //
// ./src/store/rvwdlist-store.js